var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClockDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BinDrop/Icon/clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 6V12L16 14",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockDark);
export default __webpack_public_path__ + "static/media/icon-clock-dark.bc53beaf5548eddbecd81207fb7c4a0b.svg";
export { ForwardRef as ReactComponent };